import React from 'react'
import { Helmet } from 'react-helmet-async'
import AdminSideBar from '../../Containers/AdminSideBar'
import SvodReportContainer from '../../Containers/SvodReportContainer'
import { observer } from 'mobx-react-lite'

function SvodReport() {
	return (
		<>
			<div className='ContentsWrapper ContentsWrapper2'>
				<Helmet>
					<meta charSet='utf-8' />
					<title>Сводный отчет | АВН БТ</title>
				</Helmet>
				<AdminSideBar />
				<SvodReportContainer />
			</div>
		</>
	)
}

export default observer(SvodReport)
